export type FeatureFlagUserData = {
  country: string | undefined;
  dateJoined: number; // unix milliseconds
  hasPromo: boolean;
  hasPurchasedFirstLabel: boolean;
  hasPurchasedLabel: boolean;
  hasStoreConnected: boolean;
  id: number;
  isActive: boolean;
  isE2EAutomatedTestUser: boolean;
  isE2EGetStartedUser: boolean;
  isE2ETestUser: boolean;
  isMobile: boolean;
  isPotentialFraudEmail: boolean;
  isShippoEmail: boolean;
  lifetimeVolSegmentMax: number;
  lifetimeVolSegmentMin: number;
  ordersCount: number;
  plan?: string;
  primaryCarrier: string;
  proPlanVariant: string;
  registrationStore: string;
  revenueTierName: string;
  userAgent: string;
  userId?: number;
  userType: string;
};

export type FeatureFlagUserDataPayload = {
  attributes: {
    anonymous: false;
    environmentName: string;
    insuranceByDefault: boolean | undefined;
  } & Omit<FeatureFlagUserData, 'id'>;
  id: string;
};

export enum FeatureFlagEvents {
  ACTIVE_USER_CONVERSION = 'Active User Conversion',
  LABEL_PURCHASED = 'Label Purchased',
  ONBOARDING_COMPLETED = 'Onboarding Completed',
  ONBOARDING_STEP_COMPLETED = 'Step Completed',
  PAYMENT_METHOD_ADDED = 'Payment Method Added',
  PRO_PLAN_TRIAL_STARTED = 'Pro Plan Trial Started',
}
